import { css } from '@emotion/react';
import { Gray } from '@constants/color';

export const buttonContainer = css({
  width: 512,
  backgroundColor: Gray.Gray90,
  padding: '180px 64px 64px',
  display: 'flex',
  flexDirection: 'column'
});

export const existingUserButtons = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: 40
});

export const newUserButton = css({
  marginTop: 40
});

export const title = css({
  marginTop: 80,
  fontWeight: 700,
  fontSize: 48,
  lineHeight: '62.4px'
});

export const buttonTitle = css({
  fontSize: 32,
  lineHeight: '41.6px',
  fontWeight: '700'
});
